import { z } from 'zod';
import { toNumber } from '../../Utility';
import { isNullish, Nullish } from '../../Utility/Nullish';

/**
 * @throws ZodError if marshalled value is not a whole number or is `NaN`.
 */
export function zMarshalToStrictInt(val: string | number, ctx: z.RefinementCtx): number {
    const parsed = toNumber(val);

    if (isNaN(parsed)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Not a number',
        });
        return z.NEVER;
    }

    if (!Number.isInteger(parsed)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Not an integer',
        });
        return z.NEVER;
    }

    return parsed;
}

/**
 * @throws ZodError if marshalled value is not a whole number or is `NaN`.
 */
export function zMarshalToStrictIntNullable(
    val: string | number | Nullish,
    ctx: z.RefinementCtx
): number | null {
    return isNullish(val) ? null : zMarshalToStrictInt(val, ctx);
}
